type RiskBaseGlobalType = {
  reduxPersistError: null | Error;
  SafeAreaInsets: { top: number; left: number; right: number; bottom: number };
};

export const RiskBaseGlobal: RiskBaseGlobalType = {
  reduxPersistError: null,
  SafeAreaInsets: { top: 0, left: 0, right: 0, bottom: 0 },
};
